import TextConfig from './TextConfig.jsx';
import TextareaConfig from './TextareaConfig.jsx';
import NumberConfig from './NumberConfig.jsx';
import DateConfig from './DateConfig.jsx';
import BooleanConfig from './BooleanConfig.jsx';
import RadioConfig from './RadioConfig.jsx';
import SelectConfig from './SelectConfig.jsx';
import MultiSelectConfig from './MultiSelectConfig.jsx';
import MultiCheckboxConfig from './MultiCheckboxConfig.jsx';
import ScalarListConfig from './ScalarListConfig.jsx';
import UploadConfig from './UploadConfig.jsx';
import GroupConfig from './GroupConfig.jsx';
import MarkupConfig from './MarkupConfig.jsx';
import HiddenConfig from './HiddenConfig.jsx';

const PANELS = {
  text: TextConfig,
  textarea: TextareaConfig,
  number: NumberConfig,
  date: DateConfig,
  boolean: BooleanConfig,
  radio: RadioConfig,
  select: SelectConfig,
  multi_select: MultiSelectConfig,
  multi_checkbox: MultiCheckboxConfig,
  scalar_list: ScalarListConfig,
  upload: UploadConfig,
  group: GroupConfig,
  markup: MarkupConfig,
  hidden: HiddenConfig,
};

export function panelForType(type) {
  return PANELS[type] || null;
}
